<template>
  <path
    d="M12 2.00018C6.49 2.00018 2 6.49018 2 12.0002C2 17.5102 6.49 22.0002 12 22.0002C17.51 22.0002 22 17.5102 22 12.0002C22 6.49018 17.51 2.00018 12 2.00018ZM12 20.0002C7.59 20.0002 4 16.4102 4 12.0002C4 7.59018 7.59 4.00018 12 4.00018C16.41 4.00018 20 7.59018 20 12.0002C20 16.4102 16.41 20.0002 12 20.0002ZM15 12.0002C15 13.6602 13.66 15.0002 12 15.0002C10.34 15.0002 9 13.6602 9 12.0002C9 10.3402 10.34 9.00018 12 9.00018C13.66 9.00018 15 10.3402 15 12.0002Z"
  />
</template>
